import React, { useLayoutEffect } from 'react';
import HomeHeroSection from './sections/HomeHeroSection';
import ManifestoSection from './sections/ManifestoSection';
import CorePhilosophySection from './sections/CorePhilosophySection';
import ProductLumeSection from './sections/ProductLumeSection';
import ProductPuppySection from './sections/ProductPuppySection';
import UpcomingSection from './sections/UpcomingSection';
import HomeFooter from './sections/HomeFooter';
import './HomePage.scss';

const HOME_VIEWPORT_CONTENT = 'width=1207, viewport-fit=cover';

function HomePage() {
  useLayoutEffect(() => {
    const viewportMeta = document.querySelector('meta[name="viewport"]');

    if (!viewportMeta) {
      return undefined;
    }

    const previousViewportContent = viewportMeta.getAttribute('content');
    viewportMeta.setAttribute('content', HOME_VIEWPORT_CONTENT);

    return () => {
      if (previousViewportContent) {
        viewportMeta.setAttribute('content', previousViewportContent);
      }
    };
  }, []);

  return (
    <div className="home-page">
      <div className="home-page__viewport">
        <div className="home-page__canvas">
          <main className="home-page__main">
            <HomeHeroSection />
            <ManifestoSection />
            <CorePhilosophySection />
            <ProductLumeSection />
            <ProductPuppySection />
            <UpcomingSection />
          </main>
          <HomeFooter />
        </div>
      </div>
    </div>
  );
}

export default HomePage;
